import { defineStore } from 'pinia';
import { softswiss } from '../transport/softswiss';
import { useStoreSsPlayer } from './player';
import type { ISsPlayerActiveLootbox, ISsPlayerLootbox } from '~/types/softswiss/ssPlayerLootboxes';

export type LoadBonusesOptions = {
  recreateStore?: boolean;
  force?: boolean;
};

export const useStoreSsLootboxes = defineStore('ssPlayerLootboxes', {
  state: () => ({
    lootboxes: [] as ISsPlayerLootbox[],
    isLoadedOnce: false,
  }),

  getters: {
    usableLootboxes(): ISsPlayerLootbox[] {
      return this.lootboxes.filter((lootbox) => lootbox.stage === 'issued');
    },
    wheelLootboxes(): ISsPlayerLootbox[] {
      return this.usableLootboxes.filter((lootbox) => lootbox.title === 'Wheel of Fortune');
    },
  },
  actions: {
    async loadLootboxes() {
      const storeSsPlayer = useStoreSsPlayer();
      if (!storeSsPlayer.isPlayerAuthorised) {
        return;
      }

      const lootboxes: ISsPlayerLootbox[] | null = await softswiss().get({
        path: '/api/player/lootboxes',
        force: true,
      });
      this.isLoadedOnce = true;
      this.lootboxes = lootboxes || [];
    },
    async activateLootbox(lootboxId: number) {
      const storeSsPlayer = useStoreSsPlayer();
      if (!storeSsPlayer.isPlayerAuthorised) {
        return;
      }

      const lootboxes: ISsPlayerActiveLootbox | null = await softswiss().post({
        path: `/api/player/lootboxes/${lootboxId}/activation`,
        force: true,
      });
      await this.loadLootboxes();
      return lootboxes;
    },
    resetState() {
      this.$reset();
    },
  },
});
